import { memo, forwardRef } from 'react';
import HighchartsReact from 'highcharts-react-official';

const ChartPanel = forwardRef(({ highcharts, chartOptions, callback }, ref) => {
  return (
    <HighchartsReact
      ref={ref}
      highcharts={highcharts}
      constructorType="stockChart"
      options={chartOptions}
      callback={callback}
    />
  );
});

export default memo(ChartPanel);
